import dynamic from 'next/dynamic';

export const MailSuccessDialog = dynamic(() =>
  import('./mail-success-dialog').then((mod) => mod.MailSuccessDialog)
);
